import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Typography, Box } from '@mui/material';
import AssetTable from './components/AssetTable';

export default function Assets() {
  return (
    <>
      <Helmet>
        <title>Assets | Logwork</title>
      </Helmet>

      <Container maxWidth="xl">
        <AssetTable />
      </Container>
    </>
  );
}